// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-listing-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.manage-listing-container .contents {
  margin-top: 60px;
  max-height: calc(100vh - 140px);
}
.manage-listing-container .id {
  font-size: 12px;
  font-weight: 400;
  color: #5F5F5F;
}
.manage-listing-container .id > p {
  margin: 0;
}
.manage-listing-container .table-filters {
  display: flex;
}
.manage-listing-container .table-filters > div {
  align-items: center;
  display: flex;
  column-gap: 8px;
}
.manage-listing-container .table-filters > div .status {
  width: 200px;
  height: 42px;
  border-radius: 8px;
  background-color: #F9F9F9;
  display: flex;
  position: relative;
  cursor: pointer;
}
.manage-listing-container .table-filters > div .status.active {
  border-color: var(--primary-color-1);
}
.manage-listing-container .table-filters > div .status.service {
  width: 200px;
}
.manage-listing-container .table-filters > div .status.service > p {
  width: 200px;
}
.manage-listing-container .table-filters > div .status.service .status-menu.active {
  width: 200px;
}
.manage-listing-container .table-filters > div .status > p {
  text-transform: uppercase;
  color: #5F5F5F;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  padding-left: 43px;
  align-self: center;
  width: 200px;
  display: flex;
  align-items: center;
}
.manage-listing-container .table-filters > div .status > p::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #D4D4D4;
  position: absolute;
  left: 20px;
  border-radius: 100%;
}
.manage-listing-container .table-filters > div .status > p.disabled::before {
  background-color: #C44040;
}
.manage-listing-container .table-filters > div .status > p.enabled::before {
  background-color: #02B946;
}
.manage-listing-container .table-filters > div .status > p.auto::before {
  background-color: var(--primary-color-1);
}
.manage-listing-container .table-filters > div .status > p.pending::before {
  background-color: #06C0CD;
}
.manage-listing-container .table-filters > div .status > p.active::before {
  background-color: #36C313;
}
.manage-listing-container .table-filters > div .status > p.leased::before {
  background-color: #1DD4A2;
}
.manage-listing-container .table-filters > div .status > p.sold::before {
  background-color: #FF7440;
}
.manage-listing-container .table-filters > div .status > p.soon::before {
  background-color: #BEB21A;
}
.manage-listing-container .table-filters > div .status > p.inactive::before {
  background-color: #949494;
}
.manage-listing-container .table-filters > div .status .status-menu {
  height: 0;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  background-color: white;
  border-radius: 10px;
  left: 0;
  top: 62px;
  transition: 0.2s ease-in-out;
  text-transform: uppercase;
}
.manage-listing-container .table-filters > div .status .status-menu > p {
  opacity: 0;
  display: flex;
  align-items: center;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span {
  height: 16px;
  width: 16px;
  margin-right: 10px;
  background-color: #D4D4D4;
  border-radius: 100%;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.disabled {
  background-color: #C44040;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.enabled {
  background-color: #02B946;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.auto {
  background-color: var(--primary-color-1);
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.pending {
  background-color: #06C0CD;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.active {
  background-color: #36C313;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.leased {
  background-color: #1DD4A2;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.sold {
  background-color: #FF7440;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.soon {
  background-color: #BEB21A;
}
.manage-listing-container .table-filters > div .status .status-menu > p > span.inactive {
  background-color: #949494;
}
.manage-listing-container .table-filters > div .status .status-menu.active {
  opacity: 1;
  visibility: visible;
  width: 200px;
  height: auto;
  z-index: 99;
}
.manage-listing-container .table-filters > div .status .status-menu.active > p {
  opacity: 1;
  padding-left: 20px;
  color: var(--secondary-color-2);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.manage-listing-container .table-filters > div .status .status-menu.active > p.active {
  color: var(--primary-color-1);
}
.manage-listing-container .table-filters > div .status .status-menu.active > p:hover {
  color: var(--secondary-color-1);
}
.manage-listing-container .table-filters button {
  width: 240px;
  height: 60px;
}
.manage-listing-container .action-wrapper, .manage-listing-container .show-actions {
  display: none;
}
.manage-listing-container .listing-block-container {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.manage-listing-container .listing-block-container:hover {
  opacity: 0.75;
}
.manage-listing-container .action-icons {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
}
.manage-listing-container .action-icons > div {
  cursor: pointer;
  position: relative;
}
.manage-listing-container .action-icons > div:hover::before {
  content: attr(data-name);
  position: absolute;
  height: 25px;
  width: 60px;
  background-color: var(--secondary-color-4);
  border-radius: 5px;
  top: -35px;
  left: -15px;
  font-size: 10px;
  font-weight: 700;
  color: var(--secondary-color-1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.manage-listing-container .action-icons > div.notice {
  position: relative;
}
.manage-listing-container .action-icons > div.notice::after {
  content: "";
  position: absolute;
  font-weight: 700;
  background-color: rgb(235, 74, 74);
  height: 8px;
  width: 8px;
  border-radius: 100px;
  top: 2px;
  left: 0px;
}
.manage-listing-container .action-icons > div > svg {
  cursor: pointer;
  position: relative;
}
.manage-listing-container .action-icons > div > svg:hover {
  opacity: 0.75;
}
.manage-listing-container .action-icons > div > svg:hover::after {
  content: "";
  position: absolute;
  font-weight: 700;
  width: 40px;
  height: 10px;
  top: 0;
  background-color: red;
}
.manage-listing-container .switch-container {
  display: flex;
  justify-content: center;
}
.manage-listing-container .switch-container input[type=checkbox]:checked:before {
  margin-left: 0px !important;
  border: none;
}
.manage-listing-container .switch-container .switch {
  display: inline-block;
  margin: 1.5em 0;
}
.manage-listing-container .switch-container .switch input[type=checkbox] {
  opacity: 1 !important;
  cursor: pointer;
  position: relative;
  display: inline-block;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  width: 40px;
  height: 22px;
  font-size: 2em;
  border-radius: 1.5em;
  background-color: #DFDFDF;
  border-color: transparent;
  background-clip: padding-box;
  color: white;
  vertical-align: middle;
}
.manage-listing-container .switch-container .switch input[type=checkbox]:disabled {
  cursor: not-allowed;
  background-color: #bebebe;
}
.manage-listing-container .switch-container .switch input[type=checkbox]:disabled::after {
  content: "";
}
.manage-listing-container .switch-container .switch input[type=checkbox]::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 3px;
  bottom: 0;
  right: 50%;
  background-color: #C9C9C9;
  border-radius: 100%;
  background-clip: padding-box;
  transform-origin: right center;
  transform: translateZ(0);
  backface-visibility: hidden;
  animation: switch-off-transform 0.25s ease-out forwards;
  z-index: 2;
  width: 14px;
  height: 14px;
}
.manage-listing-container .switch-container .switch input[type=checkbox]::after {
  position: absolute;
  left: 13px;
  top: 9px;
  line-height: 1.65;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0;
  word-spacing: 11px;
  z-index: 1;
}
.manage-listing-container .switch-container .switch input[type=checkbox]:focus {
  color: white;
  background-color: #bebebe;
  outline: none;
}
.manage-listing-container .switch-container .switch input[type=checkbox].auto:checked {
  background-color: var(--primary-color-1);
}
.manage-listing-container .switch-container .switch input[type=checkbox]:checked {
  color: white;
  background-color: #02B946;
}
.manage-listing-container .switch-container .switch input[type=checkbox]:checked::before {
  transform-origin: left center;
  animation: switch-on-transform 0.25s ease-out forwards;
  left: 6px;
  background-color: rgba(255, 255, 255, 0.75);
}
.manage-listing-container .pagination {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.manage-listing-container .pagination > p {
  cursor: pointer;
  font-family: "Proxima Nova", sans-serif;
  font-size: 12px;
  font-weight: 760;
  color: #949494;
}
.manage-listing-container .pagination > p:hover {
  opacity: 0.75;
}
.manage-listing-container .pagination > p.next {
  text-align: right;
}
.manage-listing-container .pagination > ul {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
}
.manage-listing-container .pagination > ul > li {
  cursor: pointer;
  font-weight: 700;
  color: var(--secondary-color-3);
  font-size: 18px;
}
.manage-listing-container .pagination > ul > li:hover {
  opacity: 0.75;
}
.manage-listing-container .pagination > ul > li.active {
  color: var(--secondary-color-1);
  text-decoration: underline;
}
.manage-listing-container .tab-choice {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
}
.manage-listing-container .tab-choice > li {
  background-color: #F9F9F9;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.manage-listing-container .tab-choice > li:hover {
  opacity: 0.75;
}
.manage-listing-container .tab-choice > li.active {
  background-color: var(--primary-color-1);
}
.manage-listing-container .tab-choice > li.active > p {
  color: white;
  font-weight: 600;
}
.manage-listing-container .tab-choice > li > p {
  font-weight: 400;
  font-size: 12px;
  color: #5F5F5F;
  padding: 0 20px;
  margin: 0;
  display: block;
}
.manage-listing-container .tab-choice > li svg {
  display: none;
}
.manage-listing-container .loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.863);
  z-index: 2;
  display: flex;
}
@keyframes switch-off-transform {
  0% {
    transform: translateX(100%) scaleX(1) translateZ(0);
  }
  25% {
    transform: translateX(100%) scaleX(1.33) translateZ(0);
  }
  100% {
    transform: translateX(0) scaleX(1) translateZ(0);
  }
}
@keyframes switch-on-transform {
  0% {
    transform: translateX(0) scaleX(1) translateZ(0);
  }
  25% {
    transform: translateX(0) scaleX(1.33) translateZ(0);
  }
  100% {
    transform: translateX(100%) scaleX(1) translateZ(0);
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .manage-listing-container .action-wrapper {
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 9;
    top: 0;
    right: 0;
  }
  .manage-listing-container .action-wrapper.show {
    display: block;
  }
  .manage-listing-container .table-filters {
    display: flex;
  }
  .manage-listing-container .table-filters > div .status {
    width: 120px;
  }
  .manage-listing-container .table-filters > div .status.service {
    width: 150px;
  }
  .manage-listing-container .table-filters > div .status.service > p {
    width: 150px;
  }
  .manage-listing-container .table-filters > div .status.service .status-menu.active {
    width: 200px;
  }
  .manage-listing-container .table-filters > div .status > p {
    width: 185px;
  }
  .manage-listing-container .table-filters > div .status .status-menu.active {
    width: 150px;
  }
  .manage-listing-container .show-actions {
    position: relative;
    display: block;
    z-index: 10;
    width: -moz-fit-content;
    width: fit-content;
  }
  .manage-listing-container .action-icons {
    height: auto;
    padding: 20px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 5px 20px 0px #EBEBEB;
    position: absolute;
    display: none;
    top: 0;
    z-index: 11;
  }
  .manage-listing-container .action-icons.show {
    display: block;
  }
  .manage-listing-container .action-icons > div {
    flex: 50% 1;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .manage-listing-container .tab-choice li {
    padding: 10px;
  }
  .manage-listing-container .tab-choice li svg {
    display: block;
  }
  .manage-listing-container .tab-choice li p {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .manage-listing-container {
    width: 100%;
  }
  .manage-listing-container .table-filters div > div:first-child {
    display: none;
  }
  .manage-listing-container .table-filters div.service {
    display: none;
  }
  .manage-listing-container .table-filters > div .status {
    width: 120px;
  }
  .manage-listing-container .table-filters > div .status > p {
    width: 185px;
  }
  .manage-listing-container .table-filters > div .status .status-menu.active {
    width: 150px;
  }
  .manage-listing-container .action-icons {
    justify-content: flex-end;
  }
  .manage-listing-container .switch-container, .manage-listing-container .status-container {
    display: flex;
    justify-content: flex-end;
  }
  .manage-listing-container .switch-container .switch, .manage-listing-container .status-container .switch {
    display: flex;
    margin: 0;
    margin-top: -10px;
  }
  .manage-listing-container .tab-choice li {
    padding: 10px;
  }
  .manage-listing-container .tab-choice li svg {
    display: block;
  }
  .manage-listing-container .tab-choice li p {
    display: none;
  }
  .manage-listing-container .listing-block-container {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/ManageListings/manageListings.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAEI;EACI,gBAAA;EACA,+BAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;AACQ;EAAM,SAAA;AAEd;AAAI;EACI,aAAA;AAER;AADQ;EACI,mBAAA;EACA,aAAA;EACA,eAAA;AAGZ;AAFY;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAIhB;AAHgB;EAAW,oCAAA;AAM3B;AALgB;EACI,YAAA;AAOpB;AANoB;EACI,YAAA;AAQxB;AANoB;EACI,YAAA;AAQxB;AALgB;EACI,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAOpB;AANoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AAQxB;AANoB;EAAqB,yBAAA;AASzC;AARoB;EAAoB,yBAAA;AAWxC;AAVoB;EAAiB,wCAAA;AAarC;AAZoB;EAAoB,yBAAA;AAexC;AAdoB;EAAmB,yBAAA;AAiBvC;AAhBoB;EAAmB,yBAAA;AAmBvC;AAlBoB;EAAiB,yBAAA;AAqBrC;AApBoB;EAAiB,yBAAA;AAuBrC;AAtBoB;EAAqB,yBAAA;AAyBzC;AAvBgB;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,SAAA;EACA,4BAAA;EACA,yBAAA;AAyBpB;AAxBoB;EACI,UAAA;EACA,aAAA;EACA,mBAAA;AA0BxB;AAzBwB;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AA2B5B;AA1B4B;EAAa,yBAAA;AA6BzC;AA5B4B;EAAY,yBAAA;AA+BxC;AA9B4B;EAAS,wCAAA;AAiCrC;AAhC4B;EAAY,yBAAA;AAmCxC;AAlC4B;EAAW,yBAAA;AAqCvC;AApC4B;EAAW,yBAAA;AAuCvC;AAtC4B;EAAS,yBAAA;AAyCrC;AAxC4B;EAAS,yBAAA;AA2CrC;AA1C4B;EAAa,yBAAA;AA6CzC;AA1CoB;EACI,UAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AA4CxB;AA3CwB;EACI,UAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA6C5B;AA5C4B;EAAW,6BAAA;AA+CvC;AA9C4B;EACI,+BAAA;AAgDhC;AAzCQ;EACI,YAAA;EACA,YAAA;AA2CZ;AAxCI;EACI,aAAA;AA0CR;AAxCI;EACI,eAAA;EACA,4BAAA;AA0CR;AAzCQ;EACI,aAAA;AA2CZ;AAxCI;EACI,aAAA;EACA,yBAAA;EACA,QAAA;AA0CR;AAzCQ;EACI,eAAA;EACA,kBAAA;AA2CZ;AA1CY;EACI,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA4ChB;AA1CY;EACI,kBAAA;AA4ChB;AA3CgB;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;AA6CpB;AA1CY;EACI,eAAA;EACA,kBAAA;AA4ChB;AA3CgB;EACI,aAAA;AA6CpB;AA5CoB;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,qBAAA;AA8CxB;AAxCI;EACI,aAAA;EACA,uBAAA;AA0CR;AAzCQ;EACI,2BAAA;EACA,YAAA;AA2CZ;AAzCQ;EACI,qBAAA;EAEA,eAAA;AA0CZ;AAzCY;EACI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;EACA,YAAA;EACA,sBAAA;AA2ChB;AA1CgB;EACI,mBAAA;EACA,yBAAA;AA4CpB;AA3CoB;EACI,WAAA;AA6CxB;AA1CgB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,uDAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA4CpB;AA1CgB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AA4CpB;AA1CgB;EACI,YAAA;EACA,yBAAA;EACA,aAAA;AA4CpB;AAtCoB;EACI,wCAAA;AAwCxB;AArCgB;EACI,YAAA;EACA,yBAAA;AAuCpB;AAtCoB;EACI,6BAAA;EACA,sDAAA;EACA,SAAA;EACA,2CAAA;AAwCxB;AAjCI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAmCR;AAlCQ;EACI,eAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAoCZ;AAnCY;EAAU,aAAA;AAsCtB;AArCY;EAAS,iBAAA;AAwCrB;AAtCQ;EACI,aAAA;EACA,uCAAA;AAwCZ;AAvCY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAyChB;AAxCgB;EAAU,aAAA;AA2C1B;AA1CgB;EACI,+BAAA;EACA,0BAAA;AA4CpB;AAtCI;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;AAwCR;AAvCQ;EACI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AAyCZ;AAxCY;EACI,aAAA;AA0ChB;AAxCY;EACI,wCAAA;AA0ChB;AAzCgB;EACI,YAAA;EACA,gBAAA;AA2CpB;AAxCY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;AA0ChB;AAxCY;EACI,aAAA;AA0ChB;AArCI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,aAAA;AAuCR;AApCI;EACI;IACI,mDAAA;EAsCV;EApCM;IACI,sDAAA;EAsCV;EApCM;IACI,gDAAA;EAsCV;AACF;AApCI;EACI;IACI,gDAAA;EAsCV;EApCM;IACI,mDAAA;EAsCV;EApCM;IACI,mDAAA;EAsCV;AACF;;AC3ZY;ED4XJ;IACI,kBAAA;IACA,aAAA;IACA,YAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;EAmCV;EAlCU;IACI,cAAA;EAoCd;EAjCM;IACI,aAAA;EAmCV;EAjCc;IACI,YAAA;EAmClB;EAlCkB;IACI,YAAA;EAoCtB;EAnCsB;IACI,YAAA;EAqC1B;EAnCsB;IACI,YAAA;EAqC1B;EAlCkB;IACI,YAAA;EAoCtB;EAjCsB;IACI,YAAA;EAmC1B;EA7BM;IACI,kBAAA;IACA,cAAA;IACA,WAAA;IACA,uBAAA;IAAA,kBAAA;EA+BV;EA7BM;IAEI,YAAA;IACA,aAAA;IACA,kBAAA;IACA,uBAAA;IACA,oCAAA;IACA,kBAAA;IACA,aAAA;IACA,MAAA;IACA,WAAA;EA8BV;EA7BU;IACI,cAAA;EA+Bd;EA7BU;IACI,WAAA;EA+Bd;AACF;ACrdY;ED6bA;IACI,aAAA;EA2Bd;EA1Bc;IACI,cAAA;EA4BlB;EA1Bc;IAAI,aAAA;EA6BlB;AACF;ACveY;EDgdR;IACI,WAAA;EA0BN;EAxBU;IACI,aAAA;EA0Bd;EAxBU;IACI,aAAA;EA0Bd;EAvBc;IACI,YAAA;EAyBlB;EAxBkB;IACI,YAAA;EA0BtB;EAvBsB;IACI,YAAA;EAyB1B;EAnBM;IACI,yBAAA;EAqBV;EAnBM;IACI,aAAA;IACA,yBAAA;EAqBV;EApBU;IACI,aAAA;IACA,SAAA;IACA,iBAAA;EAsBd;EAjBU;IACI,aAAA;EAmBd;EAlBc;IACI,cAAA;EAoBlB;EAlBc;IAAI,aAAA;EAqBlB;EAlBM;IACI,uBAAA;EAoBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.manage-listing-container {\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    font-family: \"Proxima Nova\", sans-serif;\r\n    .contents {\r\n        margin-top: 60px;\r\n        max-height: calc(100vh - 140px);\r\n    }\r\n    .id {\r\n        font-size: 12px;\r\n        font-weight: 400;\r\n        color: #5F5F5F;\r\n        > p { margin: 0 }\r\n    }\r\n    .table-filters {\r\n        display: flex;\r\n        > div {\r\n            align-items: center;\r\n            display: flex;\r\n            column-gap: 8px;\r\n            .status {\r\n                width: 200px;\r\n                height: 42px;\r\n                border-radius: 8px;\r\n                background-color: #F9F9F9;\r\n                display: flex;\r\n                position: relative;\r\n                cursor: pointer;\r\n                &.active { border-color: var(--primary-color-1); }\r\n                &.service {\r\n                    width: 200px;\r\n                    > p {\r\n                        width: 200px;\r\n                    }\r\n                    .status-menu.active {\r\n                        width: 200px;\r\n                    }\r\n                }\r\n                > p {\r\n                    text-transform: uppercase;\r\n                    color: #5F5F5F;\r\n                    font-size: 12px;\r\n                    font-weight: 600;\r\n                    margin: 0;\r\n                    padding-left: 43px;\r\n                    align-self: center;\r\n                    width: 200px;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    &::before {\r\n                        content: \"\";\r\n                        width: 16px;\r\n                        height: 16px;\r\n                        background-color: #D4D4D4;\r\n                        position: absolute;\r\n                        left: 20px;\r\n                        border-radius: 100%;\r\n                    }\r\n                    &.disabled::before { background-color: #C44040; }\r\n                    &.enabled::before { background-color: #02B946; }\r\n                    &.auto::before { background-color: var(--primary-color-1); }\r\n                    &.pending::before { background-color: #06C0CD; }\r\n                    &.active::before { background-color: #36C313; }\r\n                    &.leased::before { background-color: #1DD4A2; }\r\n                    &.sold::before { background-color: #FF7440; }\r\n                    &.soon::before { background-color: #BEB21A; }\r\n                    &.inactive::before { background-color: #949494; }\r\n                }\r\n                .status-menu {\r\n                    height: 0;\r\n                    opacity: 0;\r\n                    visibility: hidden;\r\n                    position: absolute;\r\n                    background-color: white;\r\n                    border-radius: 10px;\r\n                    left: 0;\r\n                    top: 62px;\r\n                    transition: .2s ease-in-out;\r\n                    text-transform: uppercase;\r\n                    > p { \r\n                        opacity: 0; \r\n                        display: flex;\r\n                        align-items: center;\r\n                        > span {\r\n                            height: 16px;\r\n                            width: 16px;\r\n                            margin-right: 10px;\r\n                            background-color: #D4D4D4;\r\n                            border-radius: 100%;\r\n                            &.disabled { background-color: #C44040; }\r\n                            &.enabled { background-color: #02B946; }\r\n                            &.auto { background-color: var(--primary-color-1); }\r\n                            &.pending { background-color: #06C0CD; }\r\n                            &.active { background-color: #36C313; }\r\n                            &.leased { background-color: #1DD4A2; }\r\n                            &.sold { background-color: #FF7440; }\r\n                            &.soon { background-color: #BEB21A; }\r\n                            &.inactive { background-color: #949494; }\r\n                        }\r\n                    }\r\n                    &.active {\r\n                        opacity: 1;\r\n                        visibility: visible;\r\n                        width: 200px;\r\n                        height: auto;\r\n                        z-index: 99;\r\n                        > p {\r\n                            opacity: 1;\r\n                            padding-left: 20px;\r\n                            color: var(--secondary-color-2);\r\n                            font-size: 12px;\r\n                            font-weight: 600;\r\n                            cursor: pointer;\r\n                            &.active { color: var(--primary-color-1); }\r\n                            &:hover {\r\n                                color: var(--secondary-color-1);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        button { \r\n            width: 240px; \r\n            height: 60px;\r\n         }\r\n    }\r\n    .action-wrapper, .show-actions {\r\n        display: none;\r\n    }\r\n    .listing-block-container {\r\n        cursor: pointer;\r\n        transition: .2s ease-in-out;\r\n        &:hover {\r\n            opacity: .75;\r\n        }\r\n    }\r\n    .action-icons {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: 4px;\r\n        > div {\r\n            cursor: pointer;\r\n            position: relative;\r\n            &:hover::before {\r\n                content: attr(data-name);\r\n                position: absolute;\r\n                height: 25px;\r\n                width: 60px;\r\n                background-color: var(--secondary-color-4);\r\n                border-radius: 5px;\r\n                top: -35px;\r\n                left: -15px;\r\n                font-size: 10px;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n            }\r\n            &.notice {\r\n                position: relative;\r\n                &::after {\r\n                    content: '';\r\n                    position: absolute;\r\n                    font-weight: 700;\r\n                    background-color: rgb(235, 74, 74);\r\n                    height: 8px;\r\n                    width: 8px;\r\n                    border-radius: 100px;\r\n                    top: 2px;\r\n                    left: 0px;\r\n                }\r\n            }\r\n            > svg {\r\n                cursor: pointer;\r\n                position: relative;\r\n                &:hover { \r\n                    opacity: .75;\r\n                    &::after {\r\n                        content: '';\r\n                        position: absolute;\r\n                        font-weight: 700;\r\n                        width: 40px;\r\n                        height: 10px;\r\n                        top: 0;\r\n                        background-color: red;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .switch-container {\r\n        display: flex;\r\n        justify-content: center;\r\n        input[type=checkbox]:checked:before {\r\n            margin-left: 0px !important;\r\n            border: none;\r\n        }\r\n        .switch {\r\n            display: inline-block;\r\n            // transform: scale(0.5);\r\n            margin: 1.5em 0;\r\n            input[type=checkbox] {\r\n                opacity: 1 !important;\r\n                cursor: pointer;\r\n                position: relative;\r\n                display: inline-block;\r\n                -webkit-appearance: none;\r\n                -webkit-tap-highlight-color: transparent;\r\n                width: 40px;\r\n                height: 22px;\r\n                font-size: 2em;\r\n                border-radius: 1.5em;\r\n                background-color: #DFDFDF;\r\n                border-color: transparent;\r\n                background-clip: padding-box;\r\n                color: white;\r\n                vertical-align: middle;\r\n                &:disabled {\r\n                    cursor: not-allowed;\r\n                    background-color: #bebebe;\r\n                    &::after {\r\n                        content: \"\";\r\n                    }\r\n                }\r\n                &::before {\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    top: 2px;\r\n                    left: 3px;\r\n                    bottom: 0;\r\n                    right: 50%;\r\n                    background-color: #C9C9C9;\r\n                    border-radius: 100%;\r\n                    background-clip: padding-box;\r\n                    transform-origin: right center;\r\n                    transform: translateZ(0);\r\n                    backface-visibility: hidden;\r\n                    animation: switch-off-transform 0.25s ease-out forwards;\r\n                    z-index: 2;\r\n                    width: 14px;\r\n                    height: 14px;\r\n                }\r\n                &::after {\r\n                    position: absolute;\r\n                    left: 13px;\r\n                    top: 9px;\r\n                    line-height: 1.65;\r\n                    font-size: 12px;\r\n                    font-weight: bold;\r\n                    text-transform: uppercase;\r\n                    letter-spacing: 0;\r\n                    word-spacing: 11px;\r\n                    z-index: 1;\r\n                }\r\n                &:focus {\r\n                    color: white;\r\n                    background-color: #bebebe;\r\n                    outline: none;\r\n                }\r\n                &.auto {\r\n                    // &::after {\r\n                    //     content: \"AA OFF\";\r\n                    // }\r\n                    &:checked {\r\n                        background-color: var(--primary-color-1);\r\n                    }\r\n                }\r\n                &:checked {\r\n                    color: white;\r\n                    background-color: #02B946;\r\n                    &::before {\r\n                        transform-origin: left center;\r\n                        animation: switch-on-transform 0.25s ease-out forwards;\r\n                        left: 6px;\r\n                        background-color: rgba($color: #fff, $alpha: .75);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .pagination {\r\n        display: flex;\r\n        align-items: center;\r\n        column-gap: 16px;\r\n        > p {\r\n            cursor: pointer;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            font-size: 12px;\r\n            font-weight: 760;\r\n            color: #949494;\r\n            &:hover { opacity: .75; }\r\n            &.next { text-align: right; }\r\n        }\r\n        > ul {\r\n            display: flex;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            > li { \r\n                cursor: pointer;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-3);\r\n                font-size: 18px;\r\n                &:hover { opacity: .75; }\r\n                &.active {\r\n                    color: var(--secondary-color-1);\r\n                    text-decoration: underline;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n    .tab-choice {\r\n        display: flex;\r\n        border-radius: 8px;\r\n        overflow: hidden;\r\n        > li {\r\n            background-color: #F9F9F9;\r\n            height: 32px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            cursor: pointer;\r\n            transition: .2s ease-in-out;\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n            &.active {\r\n                background-color: var(--primary-color-1);\r\n                > p {\r\n                    color: white;\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n            > p {\r\n                font-weight: 400;\r\n                font-size: 12px;\r\n                color: #5F5F5F;\r\n                padding: 0 20px;\r\n                margin: 0;\r\n                display: block;\r\n            }\r\n            svg {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    .loader {\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        background-color: rgba(255, 255, 255, 0.863);\r\n        z-index: 2;\r\n        display: flex;\r\n    }\r\n\r\n    @keyframes switch-off-transform {\r\n        0% {\r\n            transform: translateX(100%) scaleX(1) translateZ(0);\r\n        }\r\n        25% {\r\n            transform: translateX(100%) scaleX(1.33) translateZ(0);\r\n        }\r\n        100% {\r\n            transform: translateX(0) scaleX(1) translateZ(0);\r\n        }\r\n    }\r\n    @keyframes switch-on-transform {\r\n        0% {\r\n            transform: translateX(0) scaleX(1) translateZ(0);\r\n        }\r\n        25% {\r\n            transform: translateX(0) scaleX(1.33) translateZ(0);\r\n        }\r\n        100% {\r\n            transform: translateX(100%) scaleX(1) translateZ(0);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include media(tablet) {\r\n    .manage-listing-container {\r\n        .action-wrapper {\r\n            position: absolute;\r\n            height: 100vh;\r\n            width: 100vw;\r\n            z-index: 9;\r\n            top: 0;\r\n            right: 0;\r\n            &.show {\r\n                display: block;\r\n            }\r\n        }\r\n        .table-filters {\r\n            display: flex;\r\n            > div {\r\n                .status {\r\n                    width: 120px;\r\n                    &.service {\r\n                        width: 150px;\r\n                        > p {\r\n                            width: 150px;\r\n                        }\r\n                        .status-menu.active {\r\n                            width: 200px;\r\n                        }\r\n                    }\r\n                    > p {\r\n                        width: 185px;\r\n                    }\r\n                    .status-menu {\r\n                        &.active {\r\n                            width: 150px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .show-actions {\r\n            position: relative;\r\n            display: block;\r\n            z-index: 10;\r\n            width: fit-content;\r\n        }\r\n        .action-icons {\r\n            // flex-wrap: wrap;\r\n            height: auto;\r\n            padding: 20px;\r\n            border-radius: 8px;\r\n            background-color: white;\r\n            box-shadow: 0px 5px 20px 0px #EBEBEB;\r\n            position: absolute;\r\n            display: none;\r\n            top: 0;\r\n            z-index: 11;\r\n            &.show {\r\n                display: block;\r\n            }\r\n            > div {\r\n                flex: 50%;\r\n            }\r\n        }\r\n    }\r\n}\r\n@include media(tablet) {\r\n    .manage-listing-container {\r\n        .tab-choice {\r\n            li {\r\n                padding: 10px;\r\n                svg {\r\n                    display: block;\r\n                }\r\n                p { display: none; }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .manage-listing-container {\r\n        width: 100%;\r\n        .table-filters {\r\n            div > div:first-child {\r\n                display: none;\r\n            }\r\n            div.service {\r\n                display: none;\r\n            }\r\n            > div {\r\n                .status {\r\n                    width: 120px;\r\n                    > p {\r\n                        width: 185px;\r\n                    }\r\n                    .status-menu {\r\n                        &.active {\r\n                            width: 150px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .action-icons {\r\n            justify-content: flex-end;\r\n        }\r\n        .switch-container, .status-container {\r\n            display: flex;\r\n            justify-content: flex-end;\r\n            .switch {\r\n                display: flex;\r\n                margin: 0;\r\n                margin-top: -10px;\r\n            }\r\n\r\n        }\r\n        .tab-choice {\r\n            li {\r\n                padding: 10px;\r\n                svg {\r\n                    display: block;\r\n                }\r\n                p { display: none; }\r\n            }\r\n        }\r\n        .listing-block-container {\r\n            align-items: flex-start;\r\n        }\r\n    }\r\n}\r\n","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
